import { atom } from 'jotai';

export const isInspiringSearchOnboardingOpenAtom = atom(false);

export const isMobileSearchVisibleAtom = atom(false);
